import baseAPI from '@/http'

const router = 'api/projeto/eixo'
const routerMunicipioGrupo = 'api/municipio/municipioGrupoSolucao'

export const axisAPI = {
  create: (axis) => baseAPI.post(router, axis),
  update: (project) => baseAPI.put(router, project),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router + '/get-eixo'),
  get: (id) => baseAPI.get(`${router + '/get-by-projeto'}/${id}`),
  postIds: (ids) => baseAPI.post(`${router} + '/get-ids-by-projeto'`, ids),
  getByCity: (id) => baseAPI.get(`${router} + '/get-by-permissao-municipio'/${id}`),
  recoverGroup: (municipioid, municipiogruposolucaoid) => baseAPI.get(`${routerMunicipioGrupo + '/reabilitar-grupos'}/${municipioid}/${municipiogruposolucaoid}`)
}
